import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { getQuoteToolStorageKey } from '@lx/quote-tool/lite/shared/types';
import { SessionStorageService } from '@lx/shared/storage';
import { OnlineQuoteToolStore } from '../store';

@Injectable({ providedIn: 'root' })
export class PersistentStoreService {
  private readonly store = inject(OnlineQuoteToolStore);
  private readonly sessionStorageService = inject(SessionStorageService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly storageKey = getQuoteToolStorageKey();

  /**
   * Persists the state of the online quote tool store in session storage.
   * It listens to the state observable and, when it changes, saves a minimal persisted representation.
   */
  initializePersistingState(): void {
    this.store.state$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(
        ({
          currentStep,
          selectedSchool,
          selectedCourse,
          selectedDuration,
          selectedStartDate,
          selectedEndDate,
          residenceCountryCode,
          currency,
          quoteId,
          studentDetails,
        }) => {
          const currentStepId = currentStep?.id;

          if (!currentStepId) {
            this.sessionStorageService.delete(this.storageKey);
            return;
          }

          this.sessionStorageService.set(this.storageKey, {
            currentStepId,
            selectedSchool,
            selectedCourse,
            selectedDuration,
            selectedStartDate,
            selectedEndDate,
            residenceCountryCode,
            currency,
            studentDetails,
            quoteId,
          });
        },
      );
  }
}
